export default __webpack_public_path__ + "static/media/divinemercy.b9b75555.jpg";